import { call, put, takeLatest } from 'redux-saga/effects';

import { getHistoryInfo } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getHistoryInfo);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* contactInfoSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
